export const homePageHeroConfig = {
  showForm: true,
  title: 'Discover Amazing Destinations with Private Jets',
  description: 'Private Jet Charter Flights & More',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const contactsPageHeroConfig = {
  showForm: true,
  title: 'Contacts',
  description: 'Get in Touch — We’re Here to Help',
  backgroundImage: '/img/heroBlock/bg.webp',
};
export const strapiBlogPageHeroConfig = {
  showForm: true,
  title: '',
  description: '',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const aboutPageHeroConfig = {
  showForm: false,
  title: 'About Hera Flight',
  description:
    'We are a leading provider of aircraft management, sales, consulting and charter.',
  backgroundImage: '/img/heroBlock/aboutBG.webp',
};

export const servicesPageHeroConfig = {
  showForm: false,
  title: 'Our Services',
  description: 'Your Comfort, Safety, and Confidence in the Sky',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const charterPageHeroConfig = {
  showForm: true,
  title: 'Book a Private Jet Charter Flight',
  description:
    'Flexible routes, elite service, and absolute discretion — wherever you go.',
  backgroundImage: '/img/heroBlock/charterBG.webp',
};

export const aircraftSalesPageHeroConfig = {
  showForm: false,
  title: 'Aircraft Sales',
  description: 'From selection to delivery — expert support at every step.',
  backgroundImage: '/img/heroBlock/aircraftSalesBG.webp',
};

export const managementPageHeroConfig = {
  showForm: false,
  title: 'Our Team',
  description: 'Meet the Hera Flight Management Team!',
  backgroundImage: '/img/heroBlock/managementBG.webp',
};

export const availableFleetPageHeroConfig = {
  showForm: false,
  title: 'Available Fleet',
  description:
    'Explore our range of modern aircraft designed for comfort, performance, and safety—ready to elevate your next journey.',
  backgroundImage: '/img/heroBlock/available-fleet-bg.webp',
};

export const jetCardPageHeroConfig = {
  showForm: false,
  title: 'Private Jet Card Membership Program',
  description:
    'Our private jet card membership program offers superior service, access to a great fleet in private jet charters, and the most competitive pricing available.',
  backgroundImage: '/img/heroBlock/jet-card-bg.webp',
};

export const jetCard10HoursPageHeroConfig = {
  showForm: false,
  title: ' Hera Flight 10 Hour Jet Card program',
  description:
    'A flexible entry into private flying without long-term commitment. <br> <br> Our private jet card 10-hour program offers superior service, access to a great fleet in private jet charters, and the most competitive pricing available.',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const jetCard10HoursPressReleasePageHeroConfig = {
  showForm: false,
  title: 'Jet Card 10 Hours Program Press Release',
  description: '',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const heraFlightFleetExpansion2026PressReleasePageHeroConfig = {
  showForm: false,
  title: 'Hera Flight Fleet Expansion 2026 Press Release',
  description: '',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const heraFlightCitationXFleetExpansionPressReleasePageHeroConfig = {
  showForm: false,
  title: 'Hera Flight Citation X Fleet Expansion Press Release',
  description: '',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const emptyLegFlightsPageHeroConfig = {
  showForm: false,
  title: 'Empty Leg Private Jet Flights',
  description:
    'Our pre-defined departure and destination trips. These flights are perfect for short notice, cost effective travel with Hera Flight!',
  backgroundImage: '/img/heroBlock/empty-leg-bg.webp',
};

export const blogPageHeroConfig = {
  showForm: true,
  title: 'Blog & Press',
  description: 'Charter flight news and Hera Flight updates for you',
  backgroundImage: '/img/heroBlock/blog-bg.webp',
};

export const heraFlightRaceTeamPageHeroConfig = {
  showForm: false,
  title: 'Welcome to the Hera Flight Race Team',
  description: 'Interested in Sponsorship or Partnership Information?',
  backgroundImage: '/img/heroBlock/race-team-bg.webp',
};

export const jobsPageHeroConfig = {
  showForm: false,
  title: 'Join the Hera Flight Team!',
  description:
    'We’re dedicated to providing exceptional luxury travel experiences.',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const vacancyPageHeroConfig = {
  showForm: false,
  title: 'Operations Coordinator',
  description: '',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const vacancyPilotPageHeroConfig = {
  showForm: false,
  title: 'Pilot at the Hera Group',
  description: '',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const aircraftManagementPageHeroConfig = {
  showForm: false,
  title: 'Aircraft Management',
  description: 'Maximize Your Jet’s Potential with Expert management.',
  backgroundImage: '/img/heroBlock/aircraft-management-bg.webp',
};

export const ppcLpDesignPageHeroConfig = {
  showForm: true,
  title: "Discover the World's Most Amazing Places",
  description: 'Private Jet Charter Flights & More',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const promotionsPageHeroConfig = {
  showForm: false,
  title: 'Hera Flight Promotions',
  description: 'We run promotions for our Jet Cards from time-to-time.',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const citationXPageHeroConfig = {
  showForm: false,
  title: 'Citation-X',
  description: 'Large features, light aircraft',
  backgroundImage: '/img/heroBlock/aircraft-management-bg.webp',
};

export const falcon2000PageHeroConfig = {
  showForm: false,
  title: 'Falcon 2000',
  description: 'Elegant, efficient - and affordable',
  backgroundImage: '/img/heroBlock/aircraft-management-bg.webp',
};

export const privacyPolicyPageHeroConfig = {
  showForm: false,
  title: 'Privacy Policy',
  description: 'Last updated: June 2026',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const termsOfServicePageHeroConfig = {
  showForm: false,
  title: 'Terms of Service',
  description: 'Last updated: December 26th, 2025',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const privateJetNewOrleansLaPageHeroConfig = {
  showForm: true,
  title: 'New Orleans Private Jet Flight',
  description: 'Philadelphia vs. Kansas City',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const privateJetOrlandoFlPageHeroConfig = {
  showForm: true,
  title: 'Orlando Florida Private Jet Flight',
  description: '',
  backgroundImage: '/img/heroBlock/bg.webp',
};

export const theGulfstreamIVPageHeroConfig = {
  showForm: false,
  title: 'The Gulfstream IV',
  description:
    'Experience unparalleled luxury and performance aboard the Gulfstream IV, a cornerstone of Hera Flight’s elite fleet. Designed for discerning travelers, this aircraft seamlessly combines comfort, speed, and reliability, making it the ideal choice for both business and leisure voyages.',
  backgroundImage: '/img/heroBlock/aircraft-management-bg.webp',
};

export const maintenancePageHeroConfig = {
  showForm: false,
  title: 'Aircraft Maintenance',
  description:
    'Leverage our resources and years of technical expertise to deliver your aircraft on time and within budget.',
  backgroundImage: '/img/heroBlock/aircraft-management-bg.webp',
};

export const privateJetToMiamiPageHeroConfig = {
  showForm: true,
  title: 'Private Jet Charter Miami',
  description: '',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const privateJetToLosAngelesPageHeroConfig = {
  showForm: true,
  title: 'Private Jet Charter Los Angeles',
  description: '',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const privateJetToPalmBeachPageHeroConfig = {
  showForm: true,
  title: 'Private Jet Charter Palm Beach',
  description: '',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const privateJetToMonacoPageHeroConfig = {
  showForm: true,
  title: 'Private Jet Charter Monaco',
  description: '',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};

export const privateJetToNewYorkPageHeroConfig = {
  showForm: true,
  title: 'Private Jet Charter New York',
  description: '',
  backgroundImage: '/img/heroBlock/servicesBG.webp',
};
